const o = [
	{ text: '', key: 'text.eventType.genericRun', value: 0 },
	{ text: '', key: 'text.eventType.verticalJump', value: 1 },
	{ text: '', key: 'text.eventType.horizontalJump', value: 2 },
	{ text: '', key: 'text.eventType.throw', value: 3 },
	{ text: '', key: 'text.eventType.multi', value: 4 },
	{ text: '', key: 'text.eventType.endurance', value: 5 },
	{ text: '', key: 'text.eventType.dmm', value: 6 },
	{ text: '', key: 'text.eventType.cup', value: 7 },
	{ text: '', key: 'text.eventType.children', value: 8 },
	{ text: '', key: 'text.eventType.multiTeam', value: 9 },
	{ text: '', key: 'text.eventType.sprintRun', value: 10 },
	{ text: '', key: 'text.eventType.roundRun', value: 11 },
	{ text: '', key: 'text.eventType.hurdleRun', value: 12 },
	{ text: '', key: 'text.eventType.multiCup', value: 13 },
	{ text: '', key: 'text.eventType.enduranceTeam', value: 14 },
];

function getEventTypes(_this) {
	o.forEach((x) => {
		x.text = _this.$t(x.key);
	});
	return o;
}

export default getEventTypes;
